__turbopack_context__.v({
  "card": "NewsGridCard-module-scss-module__4Iz9ma__card",
  "content": "NewsGridCard-module-scss-module__4Iz9ma__content",
  "image": "NewsGridCard-module-scss-module__4Iz9ma__image",
  "imageContent": "NewsGridCard-module-scss-module__4Iz9ma__imageContent",
  "metaRow": "NewsGridCard-module-scss-module__4Iz9ma__metaRow",
  "time": "NewsGridCard-module-scss-module__4Iz9ma__time",
  "title": "NewsGridCard-module-scss-module__4Iz9ma__title",
});
